import React from 'react'
function s2013() {
  return (
    <div>
        <h3>PClassic 2013 Spring Summary</h3>
<p>
Despite Winter Storm Nemo causing a postponement of the initial February 9 date, PClassic 2013 took place on April 6, still outgrowing the 2012 iteration! Over 50 teams from 22 schools participated, coming from Pennsylvania, Maryland, New Jersey, New York, and Massachusetts!
A full list of participating schools is up <a href="https://gist.github.com/pulak1/5293266">here</a>, and a map is below!
</p>
<p>
The top 3 teams this year were:
<br />
1) <i>Westford Academy</i> - <a href="/files/photos/westford.jpg">Michael Colavita and Alok Puranik</a>
<br />
2) <i>Montgomery Blair High School</i> - Samuel Zbarsky, Victoria Tsai, Alan Du, Ashutosh Nanda
<br />
3) <i>West Windsor Plainsboro High School North (Team 2)</i> - Ernest Chiu, Jacob Edelman, Ben Edelman, Aaron Weiss
<br /> <br />
Congratulations to the winning teams! Prizes included trophies, free space on <a href="http://dropbox.com">Dropbox</a>, and <a href="http://uber.com">Uber</a> gift cards. <br />
Of the 9 contest problems this year, Westford solved all 9, Montgomery Blair solved 8, and West Windsor Plainsboro solved 7.
<br /> <br />
The teams rounding out the top 10 were:
<br />
4) West Chester High School, 6 problems
<br />
4) Dalton School (Team 1), 6 problems
<br />
6) Dalton School (Team 3), 5 problems
<br />
6) Princeton Day School (Team 1), 5 problems
<br />
6) Dalton School (Team 4), 5 problems
<br />
6) Conestoga High School (Team 3), 5 problems
<br />
6) Sherwood High School, 5 problems
<br /> <br />

The scoreboard is up <a href="https://docs.google.com/document/d/1tAEz1Up4cUJpJhECAxrl0QDkxQlC-YLvhahGVkv4QXk/edit">here</a>, and the map of Team Number to School is <a href="https://docs.google.com/spreadsheet/ccc?key=0Aha_Rxus9XXSdGpzZEhBYzBTYnFTOE1JaG9CT0ZyU2c#gid=0">here</a>
<br /> <br />

<br />

This year's question set is <a href="/problems/PClassic2013sProblems.pdf">online</a> and the test cases and solutions are available <a href="/solutions/PClassic2013sSolutions.zip">as a zip file</a>.
</p>

    </div>
  )
}

export default s2013